import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../api';

export default function BOAnalytics() {
  const { standId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.getStandAnalytics(standId).then(setData);
  }, [standId]);

  if (!data) return <div className="text-center py-20 text-[#8B7355]">Chargement...</div>;

  const maxCA = Math.max(...data.ventes_par_produit.map(v => v.ca), 1);

  return (
    <div>
      <h1 className="font-serif text-[#332A1C] text-2xl mb-8">Tableau de bord</h1>

      {/* KPIs */}
      <div className="grid grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl shadow-sm p-6 text-center">
          <p className="text-3xl font-bold text-[#C4673D] font-serif">{data.total_ca.toFixed(2)} &euro;</p>
          <p className="text-sm text-[#8B7355] mt-2">Chiffre d'affaires</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 text-center">
          <p className="text-3xl font-bold text-[#332A1C]">{data.nb_commandes}</p>
          <p className="text-sm text-[#8B7355] mt-2">Commandes</p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 text-center">
          <p className="text-3xl font-bold text-[#332A1C]">{data.panier_moyen.toFixed(2)} &euro;</p>
          <p className="text-sm text-[#8B7355] mt-2">Panier moyen</p>
        </div>
      </div>

      {/* Ventes par produit */}
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="font-serif text-[#332A1C] text-lg mb-6">Ventes par produit</h2>
        {data.ventes_par_produit.length === 0 ? (
          <p className="text-[#8B7355] text-center py-8">Aucune vente</p>
        ) : (
          <div className="space-y-4">
            {data.ventes_par_produit.map(v => (
              <div key={v.product_id}>
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-sm font-medium text-[#332A1C]">{v.nom}</span>
                  <span className="text-sm text-[#8B7355]">{v.quantite_totale} vendus — {v.ca.toFixed(2)} &euro;</span>
                </div>
                <div className="h-3 bg-[#F3DFC0] rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#C4673D] rounded-full transition-all"
                    style={{ width: `${(v.ca / maxCA) * 100}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
